import { render, staticRenderFns } from "./text_comment.vue?vue&type=template&id=03262ebe&scoped=true&"
import script from "./text_comment.vue?vue&type=script&lang=js&"
export * from "./text_comment.vue?vue&type=script&lang=js&"
import style0 from "./text_comment.vue?vue&type=style&index=0&id=03262ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03262ebe",
  null
  
)

export default component.exports